import { PropertyAddress, PropertyBasicInformation } from '../../search/searchProperty.types';
import { Address } from '../createOrderForGroupBookingUsingEmailLink.types';

export type CreateOrderForGroupBookingUsingEmailLinkDttInput = {
  propertyCode: string;
  opportunityId: string;
  quoteId: string;
  eventName: string;
  eventStartDate: string;
  eventEndDate: string;
  agentEmail: string;
  firstName: string;
  lastName: string;
  companyName: string;
  contactInformation: ContactInformation;
  paymentId: string;
  isAcrs?: boolean;
  confirmationNumber?: string;
};

export type ContactInformation = {
  email: string;
  phone: Phone;
  address: Address;
};

export enum AddressTypeDtt {
  OFFICE = 'OFFICE',
  HOME = 'HOME',
}

type Phone = {
  type: AddressTypeDtt;
  number: string;
};

export type CreateOrderForGroupBookingUsingEmailLinkDttResponse = {
  basicInformation: {
    externalIdInfo: { id: string }[];
  };
  confirmationNumber: string;
  property: Property;
};

type Property = {
  basicInformation: PropertyBasicInformation;
  contactInformation: { address: PropertyAddress };
};

export type ErrorResponseDtt = {
  errors: {
    code: string;
    httpStatus: number;
    errors: {
      code: string;
      devMessage: string;
      message: string;
    }[];
  }[];
};
